import React from "react";
import pinkIcons from "../../../../images/icons/pink-check.png";
import careerImage from "./images/career-assessment.png";
import { useNavigate } from "react-router-dom";

const AssessmentsHighlights = () => {
  const items = [
    {
      title: "Your AI Exposure  and Complementarity Score",
    },
    {
      title: "Task Automation Report",
    },
    {
      title: "Career Recommendations with lower AI risks",
    },
    {
      title: "Skills Gap Analysis",
    },
    {
      title: "And More",
    },
  ];
  const navigate = useNavigate();
  return (
    <>
      <div className="bg-[#f7faff] w-full mx-auto py-10 px-5 md:px8 max-w-screen-xl flex flex-col md:flex-row md:gap-8 ">
        {/* {Assessment heading div} */}
        <div className="flex-1 bg-grey p-6 shahdow-md rounded-lg">
          {/* {heading div} */}
          <div className="flex items-center">
            <h1 className="text-custom-navy text-2xl md:text-4xl  font-bold">
              Key Items on your Assessment Report
            </h1>
          </div>

          {/* {paragraph div} */}
          <div className="flex flex-col gap-3 my-6">
            {items.map((item, index) => (
              <div className="flex items-start gap-2.5">
                <img src={pinkIcons} alt="pink check" className="w-5 h-5" />
                <p className="text-sm md:text-base">{item.title}</p>
              </div>
            ))}
            {/* {div for Confidential & secure} */}

            <button
              onClick={() => navigate("/auth/login")}
              className=" w-[50%] bg-custom-gradient text-white p-3 text-xs md:text-base md:px-8 md:py-4 rounded-full hover:underline my-8"
            >
              Start Your Assessment
            </button>
          </div>
        </div>

        {/* {image div} */}
        <div className="flex-1 bg-grey p-6 shahdow-md rounded-lg">
          <img
            src={careerImage}
            alt="People"
            className="mt-4 w-[698px] h-auto"
          />
        </div>
      </div>
    </>
  );
};

export default AssessmentsHighlights;
